import type { TFunction } from 'i18next'

import type { BidDetailColumnGroup, BidDetailDataColumn } from '@/features/bidding/components/bidDetail/table/types'

/**
 * Energy-tab column configuration consumed by the generic table shell.
 */
export function buildBidEnergyColumns(t: TFunction): Readonly<{
  columnGroups: ReadonlyArray<BidDetailColumnGroup>
  dataColumns: ReadonlyArray<BidDetailDataColumn>
}> {
  return {
    columnGroups: [{ label: t('bidding.results.column.current_acknowledged'), span: 5 }],
    dataColumns: [
      { label: t('bidding.results.header.ptu'), span: 2, valign: 'bottom', align: 'center', minWidth: 150 },
      { label: t('bidding.results.activation_group'), span: 2, valign: 'bottom', align: 'center', minWidth: 150 },
      { label: t('bidding.results.header.step'), align: 'center', width: 180 },
      { label: t('bidding.results.column.price_eur_mwh'), align: 'center', width: 180 },
      { label: t('bidding.results.column.volume_mw'), align: 'center', width: 180 },
    ],
  }
}
